const m16Section = {
  id: 'PT',
  name: '2024ScoresheetM16PrecisionTokensLabel',
  fields: [
    {
      scoring: '2024ScoresheetM16TokensSub1Label',
      id: 'precision_tokens',
      options: [
        {
          description: '0',
          value: 0
        },
        {
          description: '1',
          value: 1
        },
        {
          description: '2',
          value: 2
        },
        {
          description: '3',
          value: 3
        },
        {
          description: '4',
          value: 4
        },
        {
          description: '5',
          value: 5
        },
        {
          description: '6',
          value: 6
        }
      ]
    },
  ]
}

export default m16Section;

